import isIe from 'scripts/lib/is_ie';

// modified from on https://stackoverflow.com/a/8218367
const allowedTargets = /INPUT|SELECT|TEXTAREA/i;
const preventBackspaceNavigation = function(e) {
  // 8 == backspace
  if (e.which === 8) {
    if (!allowedTargets.test(e.target.tagName) || e.target.disabled || e.target.readOnly) {
      e.preventDefault();
    }
  }
};

export default {
  UNSAFE_componentWillMount() {
    // only prevent behavior on IE where it is prominent
    // so as to avoid unnecessary performance degredation
    if (isIe()) {
      document.addEventListener('keydown', preventBackspaceNavigation);
    }
  },
  componentWillUnmount() {
    if (isIe()) {
      document.removeEventListener('keydown', preventBackspaceNavigation);
    }
  },
};



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/lib/prevent_backspace_navigation_mixin.js